<div class="pending-container">
  <mat-card class="pending-card">
    <mat-card-content>
      <img src="/assets/img/hc-logo-toolbar.png" alt="Healthy Contracts" class="pending-logo" />

      <mat-icon class="pending-icon">hourglass_empty</mat-icon>

      <h1 class="pending-title">Account pending activation</h1>

      <p class="pending-message">
        You're signed in successfully, but an administrator needs to activate your
        account before you can access {{ orgFormalName }}.
      </p>

      @if (adminName || adminEmail) {
        <p class="pending-contact">
          Need access? Contact
          @if (adminEmail) {
            <a [href]="'mailto:' + adminEmail">{{ adminName || adminEmail }}</a>
          } @else {
            <span>{{ adminName }}</span>
          }.
        </p>
      }
    </mat-card-content>

    <mat-card-actions class="pending-actions">
      <button mat-raised-button color="primary" (click)="logout()">Log out</button>
    </mat-card-actions>
  </mat-card>
</div>
